import React from 'react';
import I18n from 'i18n-js';

const AssignmentMadeTooltipContent = () => (
  <div>
    <div className="tw-font-bold">{I18n.t('assignment_already_created_header')}</div>
    <hr className="tw-my-1.5" />
    <div>
      {I18n.t('assignment_already_created')}
      {' '}
      {I18n.t('go_to_assignments_to_review')}
    </div>
  </div>
);

export default AssignmentMadeTooltipContent;
